import app from '../app';
import type Mithril from 'mithril';
import User from '../models/User';

/**
 * The `uid` helper displays a user's uid in a <span className="username">
 * tag. If the user doesn't exist, the uid will be displayed as [deleted].
 */
export default function uid(user: User | null | undefined | false): Mithril.Vnode {
  const uid = (user && user.username()) || app.translator.trans('core.lib.username.deleted_text');

  return <span className="username">{uid}</span>;
}